export const GOOGLE_MAP_API_KEY = 'AIzaSyC7VtmDMj_WEZmHVcR1CRAntFzkcZtVD8E';
